import SimpleCards from './SimpleCards'

export default SimpleCards
